import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import img from '../assets/others/11102046.jpg'
import img2 from '../assets/others/11102047.jpg'
import img3 from '../assets/others/11102048.jpg'
import img4 from '../assets/others/11102049.png'
import img5 from '../assets/others/11102050.png'
import g1 from '../assets/gallery/2W6A9941.jpg'
import g2 from '../assets/gallery/2W6A9942.jpg'
import g3 from '../assets/gallery/2W6A9943.jpg'
import g4 from '../assets/gallery/2W6A9768.jpg'
import g5 from '../assets/gallery/2W6A9944.jpg'
import g6 from '../assets/gallery/2W6A9815.jpg'
import g7 from '../assets/gallery/2W6A9806.jpg'
import g8 from '../assets/gallery/2W6A9712.jpg'
import g9 from '../assets/gallery/2W6A9749.jpg'
import Companysec from '../Components/Companysec/Companysec'
import Accordion from 'react-bootstrap/Accordion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import Reviewsec from '../Components/Reviewsec/Reviewsec'
import Videoreview from '../Components/Videoreviewsec/Videoreview'
import Recruitersec from '../Components/Recruitersec/Recruitersec'
import Placetable from '../Components/Placetable/Placetable'
import Clientsay from '../Components/Clientsay/Clientsay'
import { Helmet } from 'react-helmet-async'
library.add(fas)

const Placement = () => {

  return (
    <div>
      <Helmet>
      <title>VLSI Placements & Success Stories of Students | Takshila VLSI</title>
      <meta name="description" content="Discover VLSI placement records and student success stories showcasing job-oriented training and career opportunities with leading semiconductor companies at Takshila VLSI." />
      <link rel="canonical" href="https://www.takshila-vlsi.com/placements/" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="VLSI Placements & Success Stories of Students | Takshila VLSI" />
      <meta property="og:description" content="Discover VLSI placement records and student success stories showcasing job-oriented training and career opportunities with leading semiconductor companies at Takshila VLSI." />
      <meta property="og:url" content="https://www.takshila-vlsi.com/placements/" />
      <meta property="og:site_name" content="Takshila VLSI" />
      <meta property="article:modified_time" content="2024-08-14T13:16:52+00:00" />
      <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      
      <Header/>
        <main>
        <section className='section-banner pg-banner'>
            <div class="container text-center">
                          <div class="row justify-content-around ">
                              <div class="col-md p-5">
                                <div class="pg-title-sec pl-r-12">
                                    <h1 className='pg-title pb-3'>Career Assistance & Placement Support</h1>
                                    <p className='pg-title-desc'>Providing Guidance Every Step of the Way on Your VLSI Journey </p>
                                </div>
                              </div>
                          </div>
                          <div className='row justify-content-center'>
                          <div class="col-lg-3 img-radius align-self-end d-none d-sm-block">
                            <img src={img} alt=''/>
                          </div>
                          <div class="col-lg-4 img-radius align-self-end">
                            <img src={img2} alt=''/>
                          </div>
                          <div class="col-lg-3 img-radius align-self-end d-none d-sm-block">
                            <img src={img3} alt=''/>
                          </div>
                          </div>
            </div>
            </section>
            <Companysec/>
            <section className='about-section ws-section pb-5'>
            <div class="container">
                          <div class="row justify-content-around ">
                              <div class="col-lg-4">
                                <div class="pg-title-sec">
                                    <h2 class="ws-section_heading mb-3 txt-3">About our 100% Placement</h2>
                                </div>
                              </div>
                              <div class="col-lg-8">
                                <div class="pg-title-sec">
                                <p>Throughout the years, Takshila has proven to be a force to reckon as a launching pad for individuals venturing into the VLSI industry. The uniqueness and quality of our training provided are evident in the high placement of our students in various companies.
                                </p>
                                <p>We provide a 100% placement assistance to all our students who has successfully completed our flagship programs. Additionally, our placements are always in relevant companies where your skill is applicable.
                                </p>
                                <p>Aside from the skill and technical knowledge impacted in our students, we also render pre-placement guidance for our students. 
                                </p>
                                </div>
                              </div>
                          </div>
                          <div className='row pt-4 g-3'>
                          <div class="col-lg-3">
                            <div className='icon-box-2 d-flex bg-drk-4 dark-bg radius-1 p-3'>
                                <div className='icon-lft txt-2'><FontAwesomeIcon icon="fa-solid fa-play" /></div>
                                <div className='content-rht ps-3 align-self-center'>Technical or course refresher session</div>
                            </div>
                          </div>
                          <div class="col-lg-3">
                            <div className='icon-box-2 d-flex bg-drk-4 dark-bg radius-1 p-3'>
                                <div className='icon-lft txt-2'><FontAwesomeIcon icon="fa-solid fa-play" /></div>
                                <div className='content-rht ps-3 align-self-center'>Soft skill training</div>
                            </div>
                          </div>
                          <div class="col-lg-3">
                            <div className='icon-box-2 d-flex bg-drk-4 dark-bg radius-1 p-3'>
                                <div className='icon-lft txt-2'><FontAwesomeIcon icon="fa-solid fa-play" /></div>
                                <div className='content-rht ps-3 align-self-center'>Series of Aptitude and Technical Tests</div>
                            </div>
                          </div>
                          <div class="col-lg-3">
                            <div className='icon-box-2 d-flex bg-drk-4 dark-bg radius-1 p-3'>
                                <div className='icon-lft txt-2'><FontAwesomeIcon icon="fa-solid fa-play" /></div>
                                <div className='content-rht ps-3 align-self-center'>Mock tests or interviews</div>
                            </div>
                          </div>
                          </div>
            </div>
            </section>
            <section className='ws-section pb-5'>
            <div class="container">
                <div class="row bg-11 radius-1 dark-bg justify-content-between">
                    <div class="col-lg-6 p-5 align-self-center">
                       
                    <h2 className='ws-section_heading mb-5 txt-3'>How do we achieve 100% Placement</h2>
                    <p>We follow a simple but effective placement process to give clients the best students. 
                    </p>
                    <p>Firstly, we make inquiries about the requirements of the company. The company provides the job description and eligibility criteria to Takshila. Furthermore, we provide a list of eligible students based on the criteria of our clients. 
                        </p>
                        <p>Then, the company screens and makes an announcement of shortlisted candidates. After conducting both the written test and interviews, the final students are announced. 
                        </p>
                        <p>We celebrate while the student gets their offer letter and start work.
                        </p>
                    </div>
                    <div class="col-lg-5 align-self-end p-0 img-radius">
                    <img src={img4} alt=''/>
                    </div>
                </div>
                </div>
            </section>
            <section className='map-bg'>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12 text-center">
                    <h2 className='ws-section_heading mb-5'>Placement Process</h2>
                 
                    </div>
                    <div class="col-lg-11">
                    <img src={img5} alt=''/>
                    </div>
                </div>
                </div>
            </section>
            
            <section className='ws-section pb-5'>
              <div className='container bg-2 dark-bg p-lg-5 radius-1 p-3 pt-4'>
                <div className='row '>
                    <div className='col-lg text-center'>
                    <h2 class="ws-section_heading">Placement Statistics</h2>
                  </div>
                </div>
                <Placetable/>
                
             </div>
            </section>
            <section className='student-sec pb-5'>
              
            <div class="container text-center">
              <h2 className='pg-title pb-3'>2025 Anual Placement Report</h2>
              <div class="row align-items-start">
                <div class="col-lg">
                  <div class="student-section radius-1"></div>
                </div>
              </div>
            </div>
            </section>

            <Reviewsec/>
            <Videoreview/>
            <Recruitersec/>
            <section className='ws-section clientsay-section bg-5 dark-bg pb-5'>
                        <div class="container">
                                <div class="row">
                                    <div class="col-lg text-center">
                                    <h2 className='ws-section_heading pd-03'>What Our Clinet Says</h2>
                                    </div>
                                </div>
                                <Clientsay/> 
                         </div>
                      </section>

            <section className='gallery-section'>
                <div class="container">
                                <div class="row justify-content-around text-center">
                                    <div class="col-md p-5">
                                          <h2 className='ws-section_heading pd-03'>Takshila Infrastructure & Lab
                                          </h2>
                                    </div>
                                </div>
                                
                                <div class="row">
                            <div class="col-lg-4 col-md-12 mb-4 mb-lg-0">
                              <img
                                src={g1}
                                class="w-100 shadow-1-strong rounded mb-4"
                                alt="Boat on Calm Water"
                              />

                              <img
                                src={g3}
                                class="w-100 shadow-1-strong rounded mb-4"
                                alt="Wintry Mountain Landscape"
                              />
                              <img
                                src={g4}
                                class="w-100 shadow-1-strong rounded mb-4"
                                alt="Wintry Mountain Landscape"
                              />
                            </div>

                            <div class="col-lg-4 mb-4 mb-lg-0">
                              <img
                                src={g2}
                                class="w-100 shadow-1-strong rounded mb-4"
                                alt="Mountains in the Clouds"
                              />

                              <img
                                src={g5}
                                class="w-100 shadow-1-strong rounded mb-4"
                                alt="Boat on Calm Water"
                              />
                               <img
                                src={g9}
                                class="w-100 shadow-1-strong rounded mb-4"
                                alt="Boat on Calm Water"
                              />
                            </div>

                            <div class="col-lg-4 mb-4 mb-lg-0">
                              <img
                                src={g6}
                                class="w-100 shadow-1-strong rounded mb-4"
                                alt="Waves at Sea"
                              />

                              <img
                                src={g7}
                                class="w-100 shadow-1-strong rounded mb-4"
                                alt="Yosemite National Park"
                              />
                              <img
                                src={g8}
                                class="w-100 shadow-1-strong rounded mb-4"
                                alt="Yosemite National Park"
                              />
                            </div>
                          </div>
                  </div>
                </section>



            <section className='course-faq-section ws-section p-lg-5'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg text-center'>
                    <h2 class="ws-section_heading">Frequently Asked Questions</h2>
                  </div>
                </div>
                <div className='row justify-content-center pb-lg-5'>
                    <div className='col-lg-10'>
                    <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>1. What is Takshila's success rate for VLSI placements?</Accordion.Header>
                                <Accordion.Body>
                                Takshila’s VLSI placement success rate helps you understand the authenticity of our course. Our team works for you to provide the best results and guide you to achieve your goal.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>2. How does the Takshila VLSI placements team help?</Accordion.Header>
                                <Accordion.Body>
                                Takshila offers full support to its students for VLSI job placements. Our team will help you with everything from resume-making to interview practice. Placement for every student in the company is a celebration for our team, so we all provide the best support and real feedback that will help you improve results.

                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>3. What type of VLSI employment opportunities can I expect from Takshila?</Accordion.Header>
                                <Accordion.Body>
                                At Takshila, you will find numerous VLSI employment opportunities. We connect you with companies interested in hiring fresh talent in the VLSI field, helping you find a job that matches your skills.

                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>4. Could you explain the Takshila VLSI recruitment process?</Accordion.Header>
                                <Accordion.Body>
                                The VLSI recruitment process at Takshila is smooth and supportive. We start by understanding your career goals and then guide you through job applications, interview coaching, and networking to land that perfect VLSI position.


                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>5. What makes Takshila VLSI professional placements stand out?</Accordion.Header>
                                <Accordion.Body>
                                Takshila VLSI professional placements stand out because of our personalised approach. We have many industry connections and support. We focus not only on finding you a job but also on ensuring it is the right fit for your career goals.

                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header>6. What kind of support is offered by Takshila VLSI job placements?</Accordion.Header>
                                <Accordion.Body>
                                We offer the best placement opportunities, which include career counselling, interview preparation, and access to a network of top VLSI companies. Our team is here to guide you every step until you get a placement.

                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="6">
                                <Accordion.Header>7. How can Takshila's VLSI placement services benefit my career?</Accordion.Header>
                                <Accordion.Body>
                                Takshila’s VLSI placement services will enhance your career with essential skills, industry connections, and access to top VLSI jobs. We help you start your career with the right opportunities.

                                </Accordion.Body>
                            </Accordion.Item>
                           
                            </Accordion>
                    </div>
                </div>
                <div class="row justify-content-center mt-5 pb-4">
                        <div class="col-lg-9">
                        <div class="callaction-2">
                            <div class="row">
                                <div class="col-lg-7">
                                    <h2>Don't see your questions  answered here?</h2>
                                </div>
                                <div class="col-lg-4 align-self-center text-center">

                                <a href='/contact-us/'>
                                <button class="btn-primary btn-icon ms-0">Contact Us<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                                </a>
                                </div>
                                </div> 
                            </div>
                        </div>
                        
                    </div>
            </div>
          </section>
        </main>
        <Enrollaction/>
        <Partnersec/> 
        <Footer/>
    </div>
  )
}

export default Placement